import { isSameDay, getISOWeek, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachWeekOfInterval, isWithinInterval } from "date-fns";

export const getWeeksOfMonth = (month) => {
  const debutMois = startOfMonth(month);
  const finMois = endOfMonth(month);
  const semaines = eachWeekOfInterval( { start: debutMois, end: finMois }, { weekStartsOn: 1 }); // lundi
  return semaines.map((debutSemaine) => {
    const debut = startOfWeek(debutSemaine, { weekStartsOn: 1 });
    const fin = endOfWeek(debutSemaine, { weekStartsOn: 1 });
    return { label: `S${getISOWeek(debut)}`, debut, fin, };
  });
};


export const trouverPresencesExceptionnelles = (presencesUser, semaine, joursEntrainement) => {
  if (!presencesUser || presencesUser.length === 0) return [];
  return presencesUser.filter((presence) => {
    if (!presence.is_present) return false;
    const datePresence = new Date(presence.presence_date);
    // Doit être dans la semaine en cours
    const estDansLaSemaine = isWithinInterval(datePresence, { start: semaine.debut, end: semaine.fin });
    if (!estDansLaSemaine) return false;
    // Mais ne doit correspondre à AUCUN jour d'entraînement déjà prévu (base ou exception)
    const correspondAUnJourPrevu = joursEntrainement.some((entrainement) => 
      isSameDay(entrainement.date, datePresence)
    );
    return !correspondAUnJourPrevu;
  });
};